import tableIcons, { options } from 'components/universal/table_attributes'
import { CommercialServices } from 'lib/services/api/operaitons/WorkShop/TaskLibrary/commercial'
import MaterialTable from 'material-table'
import React, { useEffect, useState } from 'react'
import Checkbox from '@material-ui/core/Checkbox';
import { Box, FormControlLabel, withStyles } from '@material-ui/core';
import GreenTick from 'assets/CheckTick.svg'
const GreyCheckbox = withStyles({
    root: {
        color: "#999999",
        '&$checked': {
            color: "#999999",
        },
        backgroundColor: "#fff"
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);
function ExceptionTable(props) {
    const { currentSelectedOrder } = props
    const [loading, setLoading] = useState(false)
    const [exceptionData, setExceptionData] = useState([])
    const exceptionColumn = [
        {
            title: "Action",
            field: "action_number",
            headerStyle: {
                textAlign: "left",
                paddingLeft: '15px'
            },
            cellStyle: {
                textAlign: "left",
                paddingLeft: '15px'
            },


        },
        {
            title: "Type",
            field: "action_category",
            headerStyle: {
                textAlign: "left",

            },
            cellStyle: {
                textAlign: "left",

            },
        },
        {
            title: "Description",
            field: "title",
            width: "40%",

            headerStyle: {
                textAlign: "left",
                width: "40%",
            },
            cellStyle: {
                textAlign: "left",
                width: "40%",
            },
        },
        {
            title: "Labour",
            field: "labour_cost",
        },

        {
            title: "Parts",
            field: "parts_cost",
        },

        {
            title: "Services",
            field: "service_cost",
        },

        {
            title: "Equipment",
            field: "equipment_cost",
        },
        {
            title: "Overall",
            field: "overview_total",
        },



        {
            title: "Action",
            field: "",
            cellStyle: {
                textAlign: "center"
            },
            render: (rowData) => <div style={{ paddingLeft: "30px" }}>
                <FormControlLabel
                    control={<GreyCheckbox checked={rowData?.status} name="" />}
                    disabled={true}
                    label=""
                />

            </div>

        },

    ]



    const getList = async () => {
        const params = {
            // page: 1 + page,
            // limit: pageSize,
            workshop_order_id: currentSelectedOrder.id,


        };
        setLoading(true)
        CommercialServices.getExceptionTableListing(params).then((res) => {

            if (res.success) {
                let data = res?.data

                if (data.length > 0) {
                    let value = data.map((item) => {
                        if (item.commercial_type === 1) {
                            item.status = true
                        }
                        return item
                    })

                    setExceptionData(value)


                }

                setExceptionData(res.data)

            }
        }).catch(() => {

        }).finally(() => {
            setLoading(false)
        })

    };
    useEffect(() => {
        getList();
    }, [currentSelectedOrder.id]);
    const tableOptions2 = {
        ...options,
        paging: false,
        search: false,


    };
    return (
        <Box style={{ height: '350px', overflow: "scroll", padding: "2px 2px" }}>

            <MaterialTable
                style={{
                    boxShadow: "0px 1px 4px #00000033",
                    //   marginTop: "10px",
                    maxBodyHeight: "350px"
                }}
                isLoading={loading}
                icons={tableIcons}
                title={""}
                columns={exceptionColumn}
                data={exceptionData || []}
                options={tableOptions2}
                components={{
                    Toolbar: () => null,
                }}
                localization={{
                    toolbar: {},
                    body: {
                        emptyDataSourceMessage: "No Records found",
                        filterRow: {
                            filterTooltip: "Filter",
                        },
                    },
                }}

            />

        </Box>
    )
}

export default ExceptionTable